import React, { useState } from "react"
import { Col, Row, Table, Form, Container } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import {
  changeStatusPurchaseOrder,
  getPurchaseOrder,
} from "../../../Helpers/apiCalls/Purchases/purchaseOrderApi"
import {
  getCurrentDateTimeYYMMDDHHMMSS,
  dateFormat,
  numberFormat,
  getSignature,
  getName,
  refreshPage,
  toastStyle,
  TokenExpiry,
} from "../../../Helpers/Utils/Common"
import toast from "react-hot-toast"
import cleanLogo from "../../../Assets/Images/Login/transparent_bg.png"
import ElmhurstLogo from "../../../Assets/Images/elmhurst-initial-logo.png"
import signature from "../../../Assets/Images/signature.png"
import Navbar from "../../../Components/Navbar/Navbar"
import Moment from "moment"
import { emailPurchaseOrder } from "../../../Helpers/apiCalls/Purchases/purchaseOrderApi"
import PIModal from "../../Purchases/Pay Suppliers/Components/PIModal"
import {
  getReceivableAging,
  emailStatementOfAccount,
} from "../../../Helpers/apiCalls/WholesaleReports/ReceivableAging"
import { getCustomer } from "../../../Helpers/apiCalls/Manage/CustomersApi"
import Footer from "../../../Components/Footer/Footer"
import SalesModal from "../../SalesModules/Component/SalesModal"
import html2canvas from "html2canvas"
import jsPDF from "jspdf"

export default function StatementOfAccount() {
  const { id } = useParams()
  let navigate = useNavigate()
  const [inactive, setInactive] = useState(true)
  // const [printPO, setPrintPO] = useState([])
  const [invoices, setInvoices] = useState([])
  const [totalReceivables, setTotalReceivables] = useState([])
  const [totalCurrent, setTotalCurrent] = useState([])
  const [totalOneToThirty, setTotalOneToThirty] = useState([])
  const [totalThirtyOneToSixty, setTotalThirtyOneToSixty] = useState([])
  const [totalSixtyOneToNinety, setTotalSixtyOneToNinety] = useState([])
  const [totalAboveNinety, setTotalAboveNinety] = useState([])
  const [showLoader, setShowLoader] = useState(false)
  const [customer, setCustomer] = useState([])
  const [contactPerson, setContactPerson] = useState([])
  const [customerAddress, setCustomerAddress] = useState([])
  const [isClicked, setIsClicked] = useState(false)
  const [prepBySignature, setPrepBySignature] = useState()
  const [showSendModal, setShowSendModal] = useState(false)
  const handleShowSendModal = () => setShowSendModal(true)
  const handleCloseSendModal = () => setShowSendModal(false)

  async function fetchReceivableAging() {
    setShowLoader(true);
    setInvoices([]);
    const response = await getReceivableAging({ customer_id: id, page: 1 });
  
    if (response.data && response.data.data && response.data.data.length > 0) {
      let invoices = response.data.data[0].all_invoices;
      invoices.sort((a, b) => new Date(a.receivables_date) - new Date(b.receivables_date));
  
      // Map the sorted invoices
      invoices = invoices.map((invoice) => {
        var info = { ...invoice };
        info.name = "invoice_id";
        info.select_variable = "invoice_id_value";
        info.label = invoice.invoice_no;
        info.value = invoice.id;
        return info;
      });

      setCustomer(response.data.data[0].trade_name);
      setContactPerson(response.data.data[0].contact_person);
      setCustomerAddress(response.data.data[0].trade_address);
      setInvoices(invoices);
  
      setTotalCurrent(response.data.data[0].current_total_balance);
      setTotalOneToThirty(response.data.data[0].one_to_thirty_balance);
      setTotalThirtyOneToSixty(response.data.data[0].thirtyone_to_sixty_balance);
      setTotalSixtyOneToNinety(response.data.data[0].sixtyone_to_ninety_balance);
      setTotalAboveNinety(response.data.data[0].above_ninety_balance);
  
      setTotalReceivables(response.data.summary.total_balance);
    } else {
      console.error("Data structure is not as expected:", response.data);
    }
    setShowLoader(false);
  }
  
     

  const handleSendEmail = async (ref) => {
    if (ref) {
      const element = document.getElementById(ref)
      setIsClicked(true)

      html2canvas(element).then(async (canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 0.7) // Adjust the quality here (0.7 is just an example)
        const pdf = new jsPDF()
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight = pdf.internal.pageSize.getHeight()
        const imgWidth = canvas.width
        const imgHeight = canvas.height
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight)
        const imgX = (pdfWidth - imgWidth * ratio) / 2
        const imgY = 5
        pdf.addImage(
          imgData,
          "JPEG",
          imgX,
          imgY,
          imgWidth * ratio,
          imgHeight * ratio
        )

        // Convert the pdf file from Blob to File obj (needed for upload API)
        var blobPdf = pdf.output("blob")

        const dateToday = getCurrentDateTimeYYMMDDHHMMSS()
        const formPdf = new File(
          [blobPdf],
          `Statement_Of_Account_${dateToday}.pdf`,
          {
            type: blobPdf.type,
          }
        )

        const response = await emailStatementOfAccount(id, formPdf)

        if (response.response) {
          toast.success(response.response.message, {
            style: toastStyle(),
          })
          setTimeout(() => {
            navigate("/receivablesagingreport", {
              params: {
                state: "sent",
              },
            })
          }, 1000)
        } else {
          setIsClicked(false)
          toast.error("Email not sent", {
            style: toastStyle(),
          })
          setTimeout(() => {
            setIsClicked(false)
            handleCloseSendModal()
          }, 1000)
        }
      })
    }
  }

  convertFromHtmlToImage()

  async function convertFromHtmlToImage() {
    const preparedBySignatureLink = getSignature()
    console.log(preparedBySignatureLink)
    try {
      const prepByBase64Data = await imageUrlToBase64(preparedBySignatureLink)
      setPrepBySignature(prepByBase64Data)
    } catch {}
  }

  async function imageUrlToBase64(url) {
    try {
      const response = await fetch(url)
      const blob = await response.blob()
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    } catch (error) {
      console.error("Error converting image URL to base64:", error)
      return null
    }
  }

  /* print modal handler */
  const [showPrintModal, setShowPrintModal] = useState(false)
  const handleShowPrintModal = () => setShowPrintModal(true)
  const handleClosePrintModal = () => setShowPrintModal(false)

  function handleViewSalesInvoice(invoice_id) {
    window.open(
      //"/se/purchaseinvoices/print/" + invoice_id,
      "/wholesaleinvoice/print/" + invoice_id,
      "_blank"
    )
  }

  React.useEffect(() => {
    convertFromHtmlToImage()
  }, [])

  function renderTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th>Date</th>
            <th>Sales Order No.</th>
            <th>Invoice No.</th>
            <th>Grand Total</th>
            <th>Paid Amount</th>
            <th>Balance</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((invoice) => {
            return (
              <tr key={invoice.invoice_id}>
                <td>
                  {Moment(invoice.receivables_date).format("MMM DD, YYYY")}
                </td>
                <td>{invoice.sales_order_no}</td>
                <td>
                  <button
                    type="button"
                    className="button-secondary table-button p-1"
                    onClick={() => handleViewSalesInvoice(invoice.invoice_id)}
                  >
                    {invoice.invoice_no && invoice.invoice_no !== null
                      ? invoice.invoice_no
                      : invoice.dr_no
                      ? invoice.dr_no
                      : invoice.invoice_id}
                  </button>
                </td>
                <td>{numberFormat(invoice.total)}</td>
                <td>{numberFormat(invoice.total_paid)}</td>
                <td>{numberFormat(invoice.total_balance)}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function renderTableTwo() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th>Current</th>
            <th>1-30</th>
            <th>31-60</th>
            <th>61-90</th>
            <th>Above 90</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{numberFormat(totalCurrent)}</td>
            <td>{numberFormat(totalOneToThirty)}</td>
            <td>{numberFormat(totalThirtyOneToSixty)}</td>
            <td>{numberFormat(totalSixtyOneToNinety)}</td>
            <td>{numberFormat(totalAboveNinety)}</td>
            <td>{numberFormat(totalReceivables)}</td>
          </tr>
        </tbody>
      </Table>
    )
  }

  function Print() {

    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    setTimeout(() => {
      // navigate("/purchaseorders");
      refreshPage();
      // setShowPrintModal(false)
    }, 1000);
  }

  React.useEffect(() => {
    // fetchPO();
    fetchReceivableAging()
  }, [])

  return (
    <div className="page">
      <div className="print-page page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"WHOLESALE REPORTS"}
        />
      </div>
      <div
        className={`print-top manager-container ${
          inactive ? "inactive" : "active"
        }`}
      >
        <div className="print-container px-3 py-2" id="printablediv">
          <div className="print-header-invoice-elm">
            <div className="print-top d-flex justify-content-center py-1 mt-5">
              <img src={ElmhurstLogo} className="print-logo-elm" alt="" />
            </div>
            <div className="print-top">
              <h5 className="print-shop-header-elm d-flex justify-content-center">
                497 D Molave Extension, Lahug, Cebu City
              </h5>
              <br />
              <h2 className="delivery-title-elm d-flex justify-content-center">
                STATEMENT OF ACCOUNT
              </h2>
              {/* <h5 className="print-shop-header fs-4 d-flex justify-content-center">STATEMENT OF ACCOUNT</h5> */}
            </div>
          </div>

          {/* content */}
          <div className="mt-5 mx-5">
            <Row className="mt-5">
              <Col className="pl-5 print-data">
                <p className="fw-bold m-0">{customer}</p>
              </Col>
              <Col className="pl-5 text-center print-data">
                Date: {Moment().format("MMM DD, YYYY")}
              </Col>
            </Row>
            <Row className="mt-1">
              <Col className="pl-5 print-data">{contactPerson}</Col>
            </Row>
            <Row className="mt-1">
              <Col className="pl-5 print-data">{customerAddress}</Col>
            </Row>
            <Row className="mt-5">
              <Col className="pl-5 print-data">Sir/Madam</Col>
            </Row>
            <Row className="mt-3">
              <Col className="pl-5 print-data">
                Received the following document(s) for purposes of checking and
                processing of payments:
              </Col>
            </Row>
            <div className="d-flex mt-3 mb-2 justify-content-evenly">
              {/* table */}
              <div className="print-table mt-3 mx-2">{renderTable()}</div>
            </div>
            {/* <Row className="mt-4">
              <span className="print-footer">{printPO.remarks}</span>
            </Row> */}
            <div className="d-flex justify-content-end mt-2 mx-5">
              <div className="print-table-footer-label mx-2">
                Total AMOUNT DUE
                <span className="mx-2 print-table-footer-data grand-label">
                  PHP {numberFormat(totalReceivables)}
                </span>
              </div>
            </div>
            <div className="print-signatories mt-5 mb-3 pb-3">
              <span>Prepared by</span>
              <span>Received by</span>
            </div>
            <div className="print-signatures">
              <div className="d-flex align-items-center justify-content-end flex-column">
                <img src={prepBySignature} alt="" className="print-logo" />
                <span className="text-center text-uppercase nc-modal-custom-text">
                  {/* {printPO.added_by_name} */}
                  {getName()}
                </span>
              </div>
              <div className="d-flex justify-content-end flex-column align-items-center">
                {/* <img src={signature} className="print-logo" alt=""/> */}
                <span className="text-center text-uppercase nc-modal-custom-text">
                  {/* APPROVERS NAME */}
                </span>
              </div>
            </div>
            <div className="print-signatories pb-3 mb-5">
              <span>Collection Department</span>
              <span>Signature over printed name</span>
            </div>

            <div className="print-signatures mt-5">
              <div className="d-flex align-items-center justify-content-end flex-column">
                <span className="text-center text-uppercase nc-modal-custom-text">
                  {/* {printPO.added_by_name} */}
                </span>
              </div>
              <div className="d-flex align-items-center justify-content-center flex-column">
                {/* <img src={signature} className="print-logo" alt=""/> */}
                <span className="text-center text-uppercase nc-modal-custom-text">
                  {/* APPROVERS NAME */}
                </span>
              </div>
            </div>
            {/* <div className="print-signatories pb-5 mb-5">
              <span>Accounting Department</span>
              <span>Date </span>
            </div> */}
            <Row>
              <Col className="pl-5 print-data">
                Status of your account as of the statement date stated including
                the above listed invoice(s):
              </Col>
            </Row>
            <div className="d-flex mt-3 mb-2 justify-content-evenly">
              {/* table */}
              <div className="print-table mt-1 mx-2">{renderTableTwo()}</div>
            </div>
          </div>
        </div>

        {/* footer */}
        <div className="d-flex justify-content-end pt-5 pb-3">
          <button
            className="button-secondary me-3"
            onClick={() => navigate("/receivablesagingreport")}
          >
            Close
          </button>
          <button className="button-primary me-3" onClick={handleShowSendModal}>
            Email to Customer
          </button>
          <button className="button-primary" onClick={handleShowPrintModal}>
            Print
          </button>
        </div>
      </div>
      <PIModal
        show={showPrintModal}
        hide={handleClosePrintModal}
        type="print"
        page="statement of account"
        // handler={handlePrintPO}
        handler={Print}
      />
      <Footer />
      <SalesModal
        show={showSendModal}
        hide={handleCloseSendModal}
        message="Are you sure want to send this statement of the account to the customer?"
        handler={() => handleSendEmail("printablediv")}
        isClicked={isClicked}
      />
    </div>
  )
}
